import initialState from './state.js'

export default {
  RESET_HOME_MODULE(state) {
    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key]
    })
  },
  SET_SUGGESTED_PRODUCTS_OPPORTUNITIES(state, payload) {
    state.homeOpportunities = payload
  },
  SET_HOME_CONSUMERS_DISTRIBUTION(state, payload) {
    state.homeConsumersDistribution = payload
  },
}
